<div>
    <input type="file" style="display: none" #filePicker (change)="onFileChanged($event)" />
    <button mat-flat-button type="button" color="primary" (click)="filePicker.click()" style="width: 100%; margin-top: 10px">
        {{ !!value ? "Fichier sélectionné" : model.additional!['LABEL'] }}
    </button> 
</div>